import {
  DEFAULT_PAGE_WIDTH,
  Divider,
  Text,
  FlatListSearchable,
} from "@towersystems/roam-common-native";
import { StockCount } from "@towersystems/roam-common/lib/generated-types";
import { Spacings, View } from "react-native-ui-lib";
import { ListItemTypes } from "../../../../utilities/list/constants";
import { SaleResourceListItemSkeleton } from "../../../sales/components/SaleResourceListItemSkeleton";
import React from "react";
import { ListWrapper } from "../../../../utilities/list/types";
import { StockCountListItem } from "../StockCountListItem";

interface StockCountResourceListProps {
  loading?: boolean;
  limit?: number;
  items: StockCount[];
  onEndReached?: () => void;
  onPressAll?: (item: StockCount) => void;
}

export const StockCountResourceList = ({
  items,
  limit = 20,
  loading,
  onEndReached,
  onPressAll,
}: StockCountResourceListProps) => {
  const renderItem = React.useCallback(
    ({ item, index }: { item: ListWrapper<StockCount>; index: any }) => {
      if (item.type === ListItemTypes.placeholder) {
        return <SaleResourceListItemSkeleton key={index} />;
      } else {
        return <StockCountListItem onPress={onPressAll} item={item.item} />;
      }
    },
    []
  );

  return (
    <FlatListSearchable
      placeholder="Search..."
      style={{
        marginBottom: Spacings.s5,
      }}
      contentContainerStyle={{
        maxWidth: DEFAULT_PAGE_WIDTH,
        width: "100%",
        alignSelf: "center",
        paddingHorizontal: Spacings.s5,
        paddingTop: Spacings.s5,
      }}
      searchBarContainerStyle={{ marginBottom: Spacings.s4 }}
      ItemSeparatorComponent={Divider}
      renderItem={renderItem}
      refreshing={loading}
      data={[
        ...items.map((item) => ({
          type: ListItemTypes.item,
          item,
        })),
        ...(loading
          ? Array(limit).fill({ type: ListItemTypes.placeholder })
          : []),
      ]}
      scrollEnabled={true}
      nestedScrollEnabled
      renderSearchBarHeader={() => <View />}
      onEndReachedThreshold={0.3}
      onEndReached={() => {
        items.length >= 1 && onEndReached && onEndReached();
      }}
    ></FlatListSearchable>
  );
};
